import React from 'react';

var ChildrenOnly = function ChildrenOnly(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

export { ChildrenOnly };